import { AmplitudeExperiments, AmplitudeVariants } from '../AmplitudeExperiments';
import { useAmplitudeExperimentBase } from '../utils/useAmplitudeExperimentBase';

export const useRemoveZipPaymentInfoExperiment = () =>
    useAmplitudeExperimentBase(
        AmplitudeExperiments.RemoveZipPaymentInfo,
        AmplitudeVariants.RemoveZipPaymentInfo.Treatment
    );
